export default __webpack_public_path__ + "static/media/William_Franklin_Male_Lion_40_x_60_cm.c4dbee7b.jpg";